import { render, staticRenderFns } from "./TestInfo.vue?vue&type=template&id=3b230b7a&scoped=true&"
import script from "./TestInfo.vue?vue&type=script&lang=js&"
export * from "./TestInfo.vue?vue&type=script&lang=js&"
import style0 from "./TestInfo.vue?vue&type=style&index=0&id=3b230b7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b230b7a",
  null
  
)

export default component.exports